/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsThreadChartColor,
    ControlcenterMelcoModelsThreadChartColorFromJSON,
    ControlcenterMelcoModelsThreadChartColorFromJSONTyped,
    ControlcenterMelcoModelsThreadChartColorToJSON,
    ControlcenterMelcoModelsThreadChartProduct,
    ControlcenterMelcoModelsThreadChartProductFromJSON,
    ControlcenterMelcoModelsThreadChartProductFromJSONTyped,
    ControlcenterMelcoModelsThreadChartProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsThreadChart
 */
export interface ControlcenterMelcoModelsThreadChart {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    file_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    version?: number;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsThreadChartColor>}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    thread_chart_color_list?: Array<ControlcenterMelcoModelsThreadChartColor> | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsThreadChartProduct>}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    product_list?: Array<ControlcenterMelcoModelsThreadChartProduct> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsThreadChart
     */
    signature?: string | null;
}

export function ControlcenterMelcoModelsThreadChartFromJSON(json: any): ControlcenterMelcoModelsThreadChart {
    return ControlcenterMelcoModelsThreadChartFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsThreadChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsThreadChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'thread_chart_color_list': !exists(json, 'thread_chart_color_list') ? undefined : (json['thread_chart_color_list'] === null ? null : (json['thread_chart_color_list'] as Array<any>).map(ControlcenterMelcoModelsThreadChartColorFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(ControlcenterMelcoModelsThreadChartProductFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function ControlcenterMelcoModelsThreadChartToJSON(value?: ControlcenterMelcoModelsThreadChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.file_name,
        'version': value.version,
        'thread_chart_color_list': value.thread_chart_color_list === undefined ? undefined : (value.thread_chart_color_list === null ? null : (value.thread_chart_color_list as Array<any>).map(ControlcenterMelcoModelsThreadChartColorToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(ControlcenterMelcoModelsThreadChartProductToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'signature': value.signature,
    };
}


